var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13248",
    "data-name": "Group 13248",
    transform: "translate(-66 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13244",
    "data-name": "Group 13244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18402",
    "data-name": "Rectangle 18402",
    width: 24,
    height: 24,
    transform: "translate(66 250)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    "data-name": "Icon awesome-users",
    d: "M3.55,9.349A2.366,2.366,0,1,0,1.183,6.983,2.369,2.369,0,0,0,3.55,9.349Zm16.565,0a2.366,2.366,0,1,0-2.366-2.366A2.369,2.369,0,0,0,20.114,9.349ZM21.3,10.532H18.931a2.359,2.359,0,0,0-1.668.688,5.408,5.408,0,0,1,2.777,4.045h2.44a1.182,1.182,0,0,0,1.183-1.183V12.9A2.369,2.369,0,0,0,21.3,10.532Zm-9.466,0A4.141,4.141,0,1,0,7.691,6.391,4.139,4.139,0,0,0,11.832,10.532Zm2.84,1.183h-.307a5.718,5.718,0,0,1-5.066,0H8.992a4.261,4.261,0,0,0-4.26,4.26V17.04a1.775,1.775,0,0,0,1.775,1.775H17.156a1.775,1.775,0,0,0,1.775-1.775V15.975A4.261,4.261,0,0,0,14.672,11.716ZM6.4,11.22a2.359,2.359,0,0,0-1.668-.688H2.366A2.369,2.369,0,0,0,0,12.9v1.183a1.182,1.182,0,0,0,1.183,1.183H3.62A5.422,5.422,0,0,1,6.4,11.22Z",
    transform: "translate(66.168 251.468)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/UserGroup.4323ada0b4e3779800fbeb4c57f962b9.svg";
export { ForwardRef as ReactComponent };